import { render, staticRenderFns } from "./descInfo.vue?vue&type=template&id=644c427e"
import script from "./descInfo.vue?vue&type=script&lang=js"
export * from "./descInfo.vue?vue&type=script&lang=js"
import style0 from "./descInfo.vue?vue&type=style&index=0&id=644c427e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports